function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "33",
  height: "26",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.047 4.764a3.617 3.617 0 10-2.677 2.39l.578.596h.735v1.033h1.034v.75l.823.8h2.793v-2.28l-3.286-3.29zM2.743 3.81a.969.969 0 100-1.938.969.969 0 000 1.938z",
  fill: "#6B1BE3",
  opacity: ".8"
})));